import { render } from "./Dialogs.vue?vue&type=template&id=b94fd0f4&scoped=true&lang=pug"
import script from "./Dialogs.js?vue&type=script&lang=js&external"
export * from "./Dialogs.js?vue&type=script&lang=js&external"

import "./Dialogs.vue?vue&type=style&index=0&id=b94fd0f4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b94fd0f4"]])

export default __exports__